import styled from 'styled-components';

import { GridContainer } from '@glowforge/gf-styled/components/grid-container';
import {
  Heading as UnstyledHeading,
  Paragraph as UnstyledParagraph,
} from '@glowforge/gf-styled/components/typography';
import { SVG } from '@glowforge/gf-styled/components';

export const Background = styled(GridContainer)`
  display: none;
  background-color: ${(props) => props.backgroundColor};

  @media ${(props) => props.theme.queries.desktopAndUp} {
    display: grid;
    width: 100%;
    color: white;
    min-height: 485px; // per spec
  }
`;

export const CarouselContainer = styled('div')`
  grid-column: main-start / main-end;
  padding-bottom: 48px;
  & * {
    // Don't allow users to select text in carousel items
    // This is a better UX
    user-select: none;
  }
`;

export const LogoRow = styled('div')`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  height: 42px;
`;

export const LogoWrapper = styled('div')`
  fill: ${(props) => (props.active ? props.theme.colors.magic.base : 'white')};
`;

export const Logo = styled(SVG)`
  &&& {
    // Remove all styling supplied by SVG component.
    fill: inherit;
    transition: fill 0.25s ease-in-out;
    stroke: none;

    // fixes safari bug; svgs as children of flex need explicit height/width
    width: 200px;
    max-width: 100%;
  }
  cursor: pointer;
`;

export const PaginationWrapper = styled('div')`
  padding-bottom: 48px;
  display: flex;
  justify-content: center;
`;

export const Wrapper = styled('div')`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  grid-column: main-start / main-end;
  padding: 80px 0 64px 0; // padding here instead of Background to account for legacy styling.
`;

export const Paragraph = styled(UnstyledParagraph)`
  text-align: center;
`;

export const Heading = styled(UnstyledHeading)`
  text-align: center;
  padding-bottom: 48px;
`;
